import {setIsPaid} from '../slices/app';

export const checkPayment = (dispatch, localPaymentStatus) => {
  if (localPaymentStatus === process.env.REACT_APP_UNPAID_SUBSCRIPTION_STATUS_ID) {
    dispatch(setIsPaid(false));
    return false;
  } else {
    dispatch(setIsPaid(true));
    return true;
  }
};
